import { MOCK_MINISTER_DETAILS, SAMPLE_MINISTER_ID } from '../../screens/minister/pages/ministerInfo/ministerInfoMock';
import type { ResumeFillData } from '../../screens/mypage/pages/resume/ResumeEdit';
import type { PortfolioEditItem } from '../../screens/mypage/pages/resume/ResumeExtrasEdit';

// 'AI작성하기' — 사역자 정보 페이지의 목데이터(상단 고정 샘플 제외)를 1건씩 이력서 폼 값으로 바꾼다
export const MOCK_FILL_SOURCES = MOCK_MINISTER_DETAILS.filter((d) => d.id !== SAMPLE_MINISTER_ID);

// 번들 이미지 URL(증명사진) → 업로드용 File
async function urlToFile(url: string, fileName: string) {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], fileName, { type: blob.type || 'image/jpeg' });
}

// 목데이터 사역사진(SVG data URI) → PNG File (포트폴리오 업로드는 jpeg/png/gif 만 허용)
function svgDataUriToPngFile(dataUri: string, fileName: string, width = 800, height = 600) {
  return new Promise<File>((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('canvas'));
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error('toBlob'));
        resolve(new File([blob], fileName, { type: 'image/png' }));
      }, 'image/png');
    };
    img.onerror = () => reject(new Error('svg load'));
    img.src = dataUri;
  });
}

export async function buildMockFill(index: number): Promise<ResumeFillData> {
  const d = MOCK_FILL_SOURCES[index];
  const no = String(index + 1).padStart(2, '0');

  const profileFile = d.profileImage ? await urlToFile(d.profileImage, `mock${no}_profile.jpeg`) : null;

  // 영상은 링크가 있어야 저장되므로(목데이터는 링크 없음) 사역사진만 옮긴다
  const photos = (d.portfolioItems || []).filter((item) => item.category === '사역사진');
  const portfolioItems: PortfolioEditItem[] = await Promise.all(
    photos.map(async (item, i) => {
      const file = await svgDataUriToPngFile(item.image, `mock${no}_photo${i + 1}.png`);
      return { ...item, image: '', file, preview: URL.createObjectURL(file) };
    }),
  );

  return {
    title: d.title,
    name: d.name,
    gender: d.gender,
    birthYear: d.birthYear,
    birthMonth: d.birthMonth,
    birthDay: d.birthDay,
    ageText: d.ageText,
    // 실제 번호와 겹치지 않도록 국번 0000 의 가상 번호 / example.com 메일
    phone: `010-0000-${String(index + 1).padStart(4, '0')}`,
    email: d.email,
    address: d.address,
    addressDetail: d.addressDetail,
    profileFile,
    educationItems: d.educationItems.map((item) => ({ ...item, description: item.description || '' })),
    careerItems: d.careerItems.map((item) => ({ ...item })),
    hopeType: d.hopeType,
    hopeLocation: d.hopeLocation,
    hopeSalary: d.hopeSalary,
    hopeSalaryPaySort: d.hopeSalaryPaySort,
    hopeRoles: d.hopeRoles,
    hopeDepartment: d.hopeDepartment,
    hopeInsurance: d.hopeInsurance,
    hopeWelfare: d.hopeWelfare,
    selfIntroduction: d.selfIntroduction || [],
    portfolioItems,
    isPublic: true,
  };
}
